module.exports = __webpack_public_path__ + "img/10372791_10152538322813267_1527738874915527755_n.4c92ad89.jpg";